import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import SEO from '../SEO/SEO';

const AuthLayout = ({ heading, subheading, footerPrompt, footerLinkLabel, footerLinkTo, children }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', bgcolor: 'background.default' }}>
      <SEO title={heading} noindex />
      <Box
        sx={{
          flex: 1,
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden',
          p: { md: 5, lg: 7 },
          color: '#fff',
          background: 'radial-gradient(90% 120% at 100% 0%, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 50%), linear-gradient(155deg, #1E3A8A 0%, #2563EB 100%)',
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            bgcolor: '#fff',
            borderRadius: 999,
            px: 1.25,
            py: 0.75,
          }}
          onClick={() => navigate('/')}
        >
          <img src="/logo.svg" alt="Remembr" style={{ height: 24, display: 'block' }} />
        </Box>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Box sx={{ maxWidth: 440, zIndex: 1 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 13.5, letterSpacing: 1, textTransform: 'uppercase', color: 'rgba(255,255,255,0.85)', mb: 1.5 }}>
              Never get overcharged twice.
            </Typography>
            <Typography sx={{ fontWeight: 800, fontSize: { md: '2.1rem', lg: '2.5rem' }, lineHeight: 1.2, mb: 2 }}>
              Track every bill and service, effortlessly.
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.78)', fontSize: 15.5 }}>
              Join the people staying on top of recurring costs, renewals and maintenance, all in one place.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', px: { xs: 3, sm: 5, md: 8 }, py: { xs: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' }, alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
          <Typography sx={{ fontSize: 13.5, color: 'text.secondary' }}>{footerPrompt}</Typography>
          <MuiLink component={Link} to={footerLinkTo} underline="hover" sx={{ fontWeight: 600, fontSize: 13.5 }}>
            {footerLinkLabel}
          </MuiLink>
        </Box>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', maxWidth: 440, mx: 'auto', py: { xs: 4, md: 0 } }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: subheading ? 0.75 : 3, fontSize: { xs: 26, md: 32 } }}>
            {heading}
          </Typography>
          {subheading && (
            <Typography sx={{ color: 'text.secondary', fontSize: 14.5, mb: 3.5 }}>{subheading}</Typography>
          )}
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
